var _ellipse, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDragDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 48,
    viewBox: "0 0 57 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.5359,
    cy: 42.31,
    rx: 27.5359,
    ry: 5.16298,
    fill: "#E0EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2604 3.08252L11.9294 3.08252C11.1118 3.08252 10.3277 3.40731 9.7496 3.98544C9.17147 4.56356 8.84668 5.34767 8.84668 6.16527V30.8273C8.84668 31.6449 9.17147 32.429 9.7496 33.0071C10.3277 33.5852 11.1118 33.91 11.9294 33.91H30.4259C31.2435 33.91 32.0276 33.5852 32.6058 33.0071C33.1839 32.429 33.5087 31.6449 33.5087 30.8273V12.3308L24.2604 3.08252Z",
    fill: "#E0EAFF",
    stroke: "#06308D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2607 3.08252V12.3308H33.509",
    stroke: "#06308D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3437 20.0381H15.0127",
    stroke: "#06308D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3437 26.2031H15.0127",
    stroke: "#06308D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0954 13.8726H16.5541H15.0127",
    stroke: "#06308D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.457,
    y: 19.7378,
    width: 13.9137,
    height: 4.91712,
    transform: "rotate(-26.2186 31.457 19.7378)",
    fill: "#E0EAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6322 22.4096L30.3754 26.3491C30.0133 27.4843 30.5109 28.7163 31.5599 29.2815L37.6631 32.5696C38.2741 32.8987 38.9941 32.9567 39.6497 32.7288C40.9198 32.2871 42.997 31.5647 45.0532 30.8496C47.8596 29.8737 49.1206 27.469 48.1039 24.5457C48.1039 24.5457 45.3155 16.5275 44.6184 14.523",
    fill: "#E0EAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6322 22.4096L30.3754 26.3491C30.0133 27.4843 30.5109 28.7163 31.5599 29.2815L37.6631 32.5696C38.2741 32.8987 38.9941 32.9567 39.6497 32.7288C40.9198 32.2871 42.997 31.5647 45.0532 30.8496C47.8596 29.8737 49.1206 27.469 48.1039 24.5457C48.1039 24.5457 45.3155 16.5275 44.6184 14.523",
    stroke: "#06308D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3426 16.411C41.3426 16.411 41.2917 16.2647 41.1102 15.7428C40.1807 13.0701 43.6887 11.8502 44.6182 14.5229",
    fill: "#06308D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3426 16.411C41.3426 16.411 41.2917 16.2647 41.1102 15.7428C40.1807 13.0701 43.6887 11.8502 44.6182 14.5229",
    stroke: "#06308D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8342 17.6312C37.8342 17.6312 37.5982 16.9526 37.2352 15.9088L37.8342 17.6312ZM37.0209 15.2925C37.0209 15.2925 37.1444 15.6479 37.2352 15.9088L37.0209 15.2925ZM41.3421 16.4112C41.3421 16.4112 41.2912 16.2649 41.1097 15.743C41.019 15.4821 40.8339 14.9499 40.7432 14.6889C39.8137 12.0162 36.3057 13.2361 37.2352 15.9088",
    fill: "#06308D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8342 17.6312C37.8342 17.6312 37.5982 16.9526 37.2352 15.9088M37.0209 15.2925C37.0209 15.2925 37.1444 15.6479 37.2352 15.9088M41.3421 16.4112C41.3421 16.4112 41.2912 16.2649 41.1097 15.743C41.019 15.4821 40.8339 14.9499 40.7432 14.6889C39.8137 12.0162 36.3057 13.2361 37.2352 15.9088",
    stroke: "#06308D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8342 17.6312C37.8342 17.6312 37.5982 16.9526 37.2352 15.9088C36.3057 13.2361 39.8137 12.0162 40.7432 14.6889C40.8339 14.9499 41.019 15.4821 41.1097 15.743C41.2912 16.2649 41.3421 16.4112 41.3421 16.4112",
    fill: "#E1E7D7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8342 17.6312C37.8342 17.6312 37.5982 16.9526 37.2352 15.9088C36.3057 13.2361 39.8137 12.0162 40.7432 14.6889C40.8339 14.9499 41.019 15.4821 41.1097 15.743C41.2912 16.2649 41.3421 16.4112 41.3421 16.4112",
    stroke: "#06308D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3268 18.851C34.3268 18.851 34.0654 18.0993 33.5135 16.5124C32.584 13.8396 36.092 12.6197 37.0215 15.2924C37.0215 15.2924 37.1451 15.6478 37.2358 15.9087C37.5988 16.9525 37.8348 17.6311 37.8348 17.6311",
    fill: "#E1E7D7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3268 18.851C34.3268 18.851 34.0654 18.0993 33.5135 16.5124C32.584 13.8396 36.092 12.6197 37.0215 15.2924C37.0215 15.2924 37.1451 15.6478 37.2358 15.9087C37.5988 16.9525 37.8348 17.6311 37.8348 17.6311",
    stroke: "#06308D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.852 25.9173L30.0055 17.732C29.6686 16.7633 30.1808 15.7049 31.1495 15.3681C32.1182 15.0312 33.1292 15.4073 33.4661 16.376C33.4815 16.4202 33.4973 16.4656 33.5134 16.5121C34.0653 18.099 34.3267 18.8507 34.3267 18.8507",
    fill: "#E1E7D7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.852 25.9173L30.0055 17.732C29.6686 16.7633 30.1808 15.7049 31.1495 15.3681C32.1182 15.0312 33.1292 15.4073 33.4661 16.376C33.4815 16.4202 33.4973 16.4656 33.5134 16.5121C34.0653 18.099 34.3267 18.8507 34.3267 18.8507",
    stroke: "#06308D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDragDrop);
export default __webpack_public_path__ + "static/media/ic-drag-drop.dc4699939ed18ac2be7644b01e5f9286.svg";
export { ForwardRef as ReactComponent };